export const emptyFieldColor = '#eedfdd';
export const fillFieldColor = '#e1ffd4';
